import {Injectable} from '@angular/core';
import {LocalStorageService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root',
})
export abstract class AbstractLocalStorageService {
  protected localStorageKey: string = '';
  protected currentValue: string;

  protected constructor(protected localStorageService: LocalStorageService) {}

  protected setLocalStorageKey(key: string): void {
    this.localStorageKey = key;
    this.currentValue = this.getStorageValue();
  }

  protected getStorageValue(): string {
    return this.localStorageService.getItem(this.localStorageKey);
  }

  protected setStorageValue(value: string): void {
    this.localStorageService.setItem(this.localStorageKey, value);
  }

  protected resetStorageValue(): void {
    this.localStorageService.removeItem(this.localStorageKey);
  }

  public getCurrent(): string {
    return this.currentValue;
  }
}
